import ChatLock from '@assets/images/common/icon/channel/lock.svg';
import SvgIconChatBalloon from '@src/assets/images/common/icon/channel/SvgIconChatBalloon';
import { ChannelVisibility } from '@src/features/shared/community/enums/channelVisibility';
import { Emoji } from 'emoji-picker-react';
import React from 'react';

export interface ChannelNameProps {
  name: string;
  emoji?: string;
  iconColor?: string;
  textClassName?: string;
  iconSize?: number;
  showIcon?: boolean;
  visibility?: ChannelVisibility;
  showLockIcon?: boolean;
}

export const ChannelName: React.FC<ChannelNameProps> = ({
  name,
  emoji,
  iconColor = '#D9D9D9',
  textClassName = 'text-sm text-gray-700',
  iconSize = 16,
  showIcon = true,
  visibility,
  showLockIcon = true,
}) => {
  const isPrivateOrLimited =
    visibility === ChannelVisibility.LIMITED || visibility === ChannelVisibility.PRIVATE;

  return (
    <div className='flex items-center gap-2 truncate'>
      {showIcon && (
        <>
          {emoji ? (
            <Emoji
              unified={emoji}
              size={iconSize}
            />
          ) : (
            <SvgIconChatBalloon
              color={iconColor}
              style={{
                width: `${iconSize}px`,
                height: `${iconSize}px`,
              }}
            />
          )}
        </>
      )}
      <span className={`flex-1 truncate ${textClassName}`}>{name}</span>
      {showLockIcon && isPrivateOrLimited && (
        <img
          className='size-4 shrink-0'
          src={ChatLock}
          alt='Private channel'
        />
      )}
    </div>
  );
};

export default ChannelName;
